<template>
  <div class="login">
    <h1>Login</h1>
    <form @submit.prevent="login" class="loader-container">
      <label for="email">Email</label>
      <input required v-model="email" type="text" name="email" value />
      <label for="password">Password</label>
      <input
        required
        v-model="password"
        type="password"
        name="password"
        value
      />
      <button class="ui-button" type="submit">Login</button>
      <Loader :loading="processing" />
    </form>
  </div>
</template>
<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
export default {
  components: { Loader },
  data: function() {
    return {
      email: "",
      password: "",
      processing: false
    };
  },
  methods: {
    login() {
      var self = this;
      self.processing = true;
      service
        .login(self.email, self.password)
        .then(response => {
          self.$store.dispatch("login", response.data).then(() => {
            self.$router.push({
              name: "Home"
            });
            self.email = "";
            self.password = "";
            self.processing = false;
          });
        })
        .catch(error => {
          self.$store.dispatch("addMessage", {
            message: "Invalid login. Please try again",
            timeout: true
          });
          console.log(error);
          self.processing = false;
        });
    }
  }
};
</script>
